// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Button from "@gcg/MobiusOverrides/Button";
import Modal from "@gcg/MobiusOverrides/Modal";
import Info from "@gcg/XDL/Icons/Info";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {getCurrentCartState} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import React, { FC, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const cartState = getCurrentCartState(state);
    const cart = cartState.value;

    return {
        isLoading: cartState.isLoading,
        cart,
    };
};


type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface CartTotalStyles {
    learnMoreModal?: LinkPresentationProps;
}

export const cartTotalStyles: CartTotalStyles = {
    learnMoreModal: {
        icon: {
            iconProps: {
                src: Info,
                size: 16,
                color: "text.main",
            },
            position: "right",
        },
    },
};

const styles = cartTotalStyles;

const BarcodeLabels: FC<Props> = ({
    isLoading,
    cart,
}) => {
    const [learnMoreModalIsOpen, setLearnMoreModelIsOpen] = useState(false);

    if (!cart?.cartLines?.length) {
        return null;
    }

    const handleCloseLearnModel = () => {
        setLearnMoreModelIsOpen(false);
    };

    return (
        <StyledWrapper
            css={css`
                @media print {
                    display: none;
                }
            `}
        >
            <StyledWrapper
                css={css`
                    margin-top: 45px;
                    text-align: center;
                `}
            >
                <Typography
                    color="text.main"
                    size="16px"
                    lineHeight="18px"
                    css={css`
                        margin-bottom: 12px;
                        display: flex;
                        justify-content: center;
                    `}
                >
                    {siteMessage("Custom_Learn_More_About_Barcodes")}
                    <Link {...styles.learnMoreModal} onClick={() => setLearnMoreModelIsOpen(true)}></Link>
                </Typography>
                <Button
                    onClick={() => window.print()}
                    variant="secondary"
                    disabled={isLoading}
                    typographyProps={{
                        css: css`
                            font-size: 14px;
                            line-height: 18px;
                            text-transform: uppercase;
                        `,
                    }}
                >
                    {translate("Print Barcode Labels")}
                </Button>
            </StyledWrapper>
            <Modal
                headline={translate("Barcode")}
                isOpen={learnMoreModalIsOpen}
                handleClose={handleCloseLearnModel}
                sizeVariant="small"
            >
                <Typography>{siteMessage("Custom_Barcode_Learn_More_data")}</Typography>
            </Modal>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(BarcodeLabels),
    definition: {
        group: "Cart",
        icon: "cart-shopping",
        allowedContexts: ["CartPage"],
    },
};

export default widgetModule;
